/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Constants for Faq data module
 */

export const CLEAR_FAQ_DATA = '@@nzr/faqData/CLEAR_FAQ_DATA' as const
export const DONE_FETCHING_FAQ_DATA = '@@nzr/faqData/DONE_FETCHING_FAQ_DATA' as const
export const ERROR_FETCHING_FAQ_DATA = '@@nzr/faqData/ERROR_FETCHING_FAQ_DATA' as const
export const RECEIVE_FAQ_DATA = '@@nzr/faqData/RECEIVE_FAQ_DATA' as const
export const START_FETCHING_FAQ_DATA = '@@nzr/faqData/START_FETCHING_FAQ_DATA' as const
